import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { LicenseManager } from "ag-grid-enterprise";
import "hammerjs";

LicenseManager.setLicenseKey(
  "OneWorks_Business_Solutions__KHFErp._1Devs25_February_2020__MTU4MjU4ODgwMDAwMA==604e683a15457bdb5931e8aace882543"
);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
